<template>
  <div class="nav_main">
    <div>
      <!-- 自动按角色加载菜单导航 -->
      <el-menu class="u_menu" :default-active="activeIndex" router :unique-opened="true">
        <!-- 训练遍历数据，根据leaf属性的值加载多级菜单还是单级菜单 -->
        <template v-for="item in permissionRoutes">
          <!-- 通过leaf属性选择不同的菜单格式 -->
          <el-submenu v-if="!item.leaf && item.menuShow" :key="item.path" :index="item.path" class="u_menu">
            <!-- 分组菜单标题 -->
            <template slot="title">
              <i :class="item.icoClass"></i>
              <span slot="title" class="text">{{ item.name }}</span>
            </template>
            <el-menu-item-group class="u_menu">
              <template v-for="trem in item.children">
                <el-menu-item v-if="trem.menuShow" :key="trem.path" :index="trem.path">
                  <span slot="title">
                    {{ trem.name }}
                  </span>
                </el-menu-item>
              </template>
            </el-menu-item-group>
          </el-submenu>
          <el-menu-item v-else-if="item.leaf && item.menuShow" :key="item.path" :index="item.path">
            <i :class="item.icoClass"></i>
            <span slot="title">{{ item.name }}</span>
          </el-menu-item>
        </template>
        <!-- 注意这里遍历要加上key标识唯一，官方文档这里没有写全 -->
      </el-menu>
    </div>
  </div>
</template>

<script>
import {  filterRoutes } from '@/composables/index'
export default {
  name: "NavComonents",
  data() {
    return {
      activeIndex: "/index", //默认打开的页面选项
      routesData: JSON.parse(localStorage.getItem("route")), //注意使用前先将字符串类型转换成对象类型
      userRoutes: JSON.parse(localStorage.getItem('menu')),
      permissionRoutes: [] // 过滤后的路由
    };
  },
  computed: {
    // filtersRoute(){
    //   return this.$store.state.filtersRoutes
    // }
  },
  created(){
    this.initRoutes()
  },
  mounted() {

  },
  methods: {
    initRoutes() {
      // 过滤权限路由
      // this.permissionRoutes = filterRoutes(this.routesData, this.userRoutes)
      this.permissionRoutes = JSON.parse(localStorage.getItem('userRoute'))
      localStorage.removeItem('route')
      localStorage.removeItem('menu')
    }
  },
};
</script>

<style lang="scss" scoped>
.nav_main {
  width: 200px;
}

.nav {
  position: relative;
}

// .nav .item {
//   height: 38px;
//   line-height: 38px;
//   text-align: left;
//   padding: 0 15px;
// }

// .nav .item:hover {
//   background: rgba(152, 196, 240, 0.6);
//   cursor: pointer;
// }
// .nav .item i {
//   color: #ffffff;
//   font-size: 16px;
//   margin-right: 8px;
// }

a.link {
  font-size: 14px;
  color: #ffffff;
  display: block;
  width: 100%;
  height: 30px;
}

/* elementui 自定义样式 */
.u_menu {
  /* background: rgb(13, 116, 219); */
  background: #FFF;
}
::v-deep {
  .el-menu-item, .el-submenu__title {
    height: 50px;
    line-height: 50px;
    list-style: none;
  }
}

.el-menu-item,
.el-menu-item i,
div.el-submenu__title i {
  color: #333;
}
.text {
  color: #333;
}
.el-menu-item:hover,.el-submenu__title:hover {
  background: rgb(13, 116, 219);
  color: #FFF;
  i{
    color: #FFF;
  }
  .text{
    color: #FFF;
  }
}

.el-menu-item.is-active {
  color: #fff;
  background: rgb(13, 116, 219);
}

/*分组标签样式修改不生效 新版本使用::v-deep才可以，/deep/无效 */

::v-deep .el-submenu .el-submenu__title:hover {
  background: rgb(13, 116, 219);
  color: #FFF;
  i{
    color: #FFF;
  }
}

::v-deep .el-menu-item-group__title {
  padding: 0;
}
</style>